import { Component, OnInit } from '@angular/core';
import { TransactionService } from 'src/app/Services/transaction.service';

@Component({
  selector: 'app-spra-consumable-billing-detail',
  templateUrl: './spra-consumable-billing-detail.component.html',
  styleUrls: ['./spra-consumable-billing-detail.component.css']
})
export class SpraConsumableBillingDetailComponent implements OnInit {
  public BillingData:any;
  public ConsBillingDetails: any[] = [];
  constructor(private _TransactionService: TransactionService) { }

  ngOnInit(): void {
    // this.GetDealerConsumableBillingDetail(1050);
  }



  GetDealerConsumableBillingDetail(PartnerId: number) {
    
    if (PartnerId != undefined && PartnerId > 0) {
      this._TransactionService.GetDealerConsumableBillingDetail(PartnerId).toPromise().then((d: any) => {
        if (d) {
    
          this.ConsBillingDetails = [];
          this.BillingData = JSON.parse(d);

          let _ProductGroupIds:number[];
          _ProductGroupIds = this.BillingData.BillingHeadingDetail.map((item:any) => item.ProductGroupId).filter((value:any, index:number, self:any) => self.indexOf(value) === index);

          let rowIndex:number=0;
          _ProductGroupIds.forEach(ProductGroupId => {
            let HeadingData:any[] = this.BillingData.BillingHeadingDetail.filter((fhd:any)=>{ return fhd.ProductGroupId == ProductGroupId});

            let BillingData = {
              Heading:HeadingData[0].HeadingName,
              TargetHeading:HeadingData[1].HeadingName,
              BillingHeading:HeadingData[2].HeadingName,
              AchievementHeading:HeadingData[3].HeadingName,
              Data:this.BillingData.BillingDetail.filter((fbd:any)=>{ return fbd.ProductGroupId == ProductGroupId})            
            }
            this.ConsBillingDetails.push(BillingData);
          });  
        }

      });
    }

  }


}
